import { Component } from '@angular/core';

@Component({
  selector: 'app-bu-company-content-en',
  templateUrl: './bu-company-content-en.component.html',
  styleUrls: [ '../../pages/bu-company/bu-company.component.css' ]
})
export class BuCompanyContentEnComponent  {

  constructor() { }


}
